var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommenticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4771 9.5151H6.52211V6.5226H24.4771V9.5151ZM24.4771 14.0038H6.52211V11.0113H24.4771V14.0038ZM24.4771 18.4926H6.52211V15.5001H24.4771V18.4926ZM30.4621 3.5301C30.4621 2.73644 30.1468 1.97528 29.5856 1.41408C29.0244 0.852878 28.2633 0.537598 27.4696 0.537598H3.52961C2.73595 0.537598 1.97479 0.852878 1.41359 1.41408C0.85239 1.97528 0.537109 2.73644 0.537109 3.5301V21.4851C0.537109 22.2788 0.85239 23.0399 1.41359 23.6011C1.97479 24.1623 2.73595 24.4776 3.52961 24.4776H24.4771L30.4621 30.4626V3.5301Z",
    fill: "#33616C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommenticon);
export default __webpack_public_path__ + "static/media/comment icon.bbe82f145f2dd354702d984417512726.svg";
export { ForwardRef as ReactComponent };